import RelationshipMetadata from "../../RelationshipMetadata";

class PositionPositionAccountUserRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "PositionPositionAccountUserRelationshipMetadata";
        this.parentEnterpriseComponent = "Position";
        this.childEnterpriseComponent = "PositionAccountUser";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "PositionUSID";
    }
}

export default PositionPositionAccountUserRelationshipMetadata;